// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/kratin_horizontal_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/kratin_vertical_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&family=Source+Code+Pro&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* font-family: 'Open Sans', sans-serif;
font-family: 'Source Code Pro', monospace; */
:root{
  --height:95vh;
}

*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Source Code Pro', monospace;
}
html {
  scroll-behavior: smooth;
}
body{
  height: 100vh;
  width: 100vw;
}
a{
  text-decoration: none;
}
textarea{
  resize: none;
  color: #fff;
}

.header{
  background-color: #c9e0f0;
  height: 5vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1.5rem;
  font-size: .75rem;
}
.header-image{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover;
  width: 75px;
  height: 90%;
}
.timer{
  display: flex;  
  align-items: center;
  column-gap: 1rem;
  justify-content: flex-end;
}

.container{
  position: absolute;
  height: var(--height);
width: 100vw;
display: grid;
grid-template-columns: 40% 50% 10%;
}
.choose_problem{
  display: flex;
  align-items: center;
  justify-content: center;
}
.editor-div{
  height: var(--height);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 0; 
  overflow-y: scroll;
  max-width: 60vw;
}
.footer-container{
  display: grid;
  gap: 1rem;
  min-width: 21vw;
  height: var(--height);
  overflow-y: scroll;
  justify-content: space-between;
}
.editor-footer{
  margin-top: 1rem; 
  display: grid;
  grid-template-columns:auto auto auto ;
  align-items: baseline;
  column-gap: .5rem;
}
.editor-bgclr{
  background-color: #050c1b;
}
.hidden { display: none; }
.flex{
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 1.5rem;
  padding-right: 2rem;
}

.btn{
  cursor: pointer;
  padding: .25rem;
  color: #fff;
  font-size: 1rem;
  text-align: center;
}
.bg-none{
  background: none;
border: none;
}
.clr-thm{
  color: #558abf;
  font-family: 'Source Code Pro', monospace;
}
.editor-element-height{
  height: 2.25rem;
}
#select-language{
  width: 10rem;
  background-color: #1D2432;
  color: #fff;
}
label[for='select-language']{
  color: #7c7975;
  margin-right: .5rem;
  font-size: 1rem;
}
.runBtn{
  background-color: #558abf;
  border-radius: 5px;
  font-family: 'Source Code Pro', monospace;
  padding: .5rem 1rem;
  flex: 2 2 20em;
}
.submitBtn{
  background-color: #19ad48;
  border-radius: 5px;
  font-family: 'Source Code Pro', monospace; 
  padding: .5rem 1rem;
  flex: 3 3 20em;
}
.custom-input{
  display: flex;
  align-items: center;
  flex: 1 1 20em;
}
.input-txt{
  width: 200px;
  height: 150px;
  resize: none;
  padding: 1rem;
}
#customInput{
  display: flex;
  align-items: baseline;
  justify-content: center;
}


.quesn{
  background-color: #111827;
  padding: 2rem;
  overflow: auto;
  font-size: 1rem;
  color: #ccd0d5;
  border: none;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  line-height: 1.5;
  resize: none;
  min-width: 20vw;
  height: var(--height);
  display: grid;
  row-gap: .75rem;
  overflow-y: scroll;
}
.quesn h3{
  margin-bottom: .5rem;
  color: #cbc8c4;
  -webkit-text-decoration: dashed;
          text-decoration: dashed;
}
.quesn ul{
  padding-left: 2rem;
}
.quesn p{
  padding-left: .5rem;
}

.output{
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  z-index: 5;
  color:white;
}
.output .message{
  height: -moz-fit-content;
  height: fit-content;
  padding-left: 2rem;
}
.output .result{
  display: grid;
  grid-template-columns: 30% 70%;
  height: 100%;
  margin-top: 1rem;
}
.bg-gray{
  background-color: #1D2432;
}
.output .testcases{
  background: #111827;
}

.io{
  padding: 2rem;
  display: grid;
}
.pad-2{
  padding:  1rem 0.5rem;
}
.mt{
  margin-top: .5rem;
}
.mb{
  margin-bottom: 1rem;
}
.cl-white{
  color: #fff;
}

.checkbox{
  margin-right: .5rem;
  accent-color: #558abf;
  filter: sepia(100%) brightness(60%) hue-rotate(170deg) saturate(70%) contrast(300%);
}
/* processing styles */
.processing{
  color: #fff;
  display: flex;
  align-items: center;
  column-gap: 1rem;
  font-size: 1rem;
  margin-left: 2rem;
}
.p-icon{
  font-size: 1.5rem;
  animation:animate 2s linear infinite;
}

@keyframes animate
{
  0%
  {
    transform:rotate(45deg);
  }
  100%
  {
    transform:rotate(405deg);
  }
}
/* split and gutter */
.split {
    display: flex;
    flex-direction: row;
    width: 100vw;
}

.gutter {
    background-color: #000;
    background-repeat: no-repeat;
    background-position: 50%;
}

.gutter.gutter-horizontal {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    cursor: col-resize;
}
/* Form */

.form {
  width: 100vw;
  height: 100vh;
  padding: 45px 65px;
  background: linear-gradient(to right, #4e86cf, #27a199);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.form__container{
  background: #fff;
  border-radius: 40px;
}
.form__box {
  width: 550px;
  height: 300px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  
}
.warning{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f51313;
  column-gap: 1rem;
}
.form__left {
  width: 50%;
}
.form__padding {
  width: 210px;
  height: 210px;
  background: #f2f2f2;
  border-radius: 50%;
  margin: 0 auto;
  line-height: 210px;
  position: relative;
}
.form__image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center/cover;
  width: 80%;
  height: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.form__right {
  line-height: 26px;
  width: 50%;
}
.form__padding-right {
  padding: 0 25px;
}
.form__title {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: .5rem;
  margin-top: 20px;
  color: #4e86cf;
}
.form .loginbtn-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.5rem;
}

.loginBtn {
  display: block;
  width: 70%;
  height: 40px;
  border-radius: 20px;
  border: none;
  background: linear-gradient(to right, #acc7ea, #539e99);
  font-size: 1rem;
  margin-top: 1rem;
}
.logoutBtn{
  border-radius: 20px;
  background: #69a7f8;
}
.header .logoutBtn{
  padding: .25rem;
  font-size: .75rem;
  color: #000;
}
.header .logoutBtn:hover {
  background: #b2e3f4;
}
.form .loginBtn:hover {
  background: linear-gradient(to right, #56b2e0, #bb52db);
}
#form__submit-btn{
  background: #1fcc44;
  cursor: pointer;
}
/* end form */



/* ------------------------Instructions---------------------- */
.instruction{
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.ins_container{
  position: relative;
  top: 3rem;
  height: 100vh;
  width: 1000px;
  background-color: rgb(251, 251, 251);
  box-shadow: 0 0px 0px rgb(251, 251, 251);
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal__image{ 
  position: absolute;
  height: 100px;
  width: 100px;
  top: -4% ;
  left: 50%;
  transform: translateX(-50%);
}
.ins_box{
  position: absolute;
  top: 10% ;
  text-align: left;
  height: 100%;
  width: 100%;
  padding-left: 2rem;
  padding-right: 1rem;

}
.ins_box h1, .ins_box h2{
  text-align: center;
  margin-bottom: 1.5rem;
}
.ins_box ul{
  list-style-type: circle;
  line-height: 1.5rem;
}
.ins_box li{
  padding-left: 1rem;
}
.ins_forward {
  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%); 
  background-color: #ffffff; /* Adjust as needed */
  padding: 1rem; /* Adjust padding as needed */
  border-radius: 8px; /* Add border-radius for styling */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Add shadow for depth */
}


/* ------------------------End of Instructions---------------------- */

/* ------Page not found */
.pagenotfound{
  display: grid;
  align-items: center;
  justify-content: center;
  padding: .5rem;
}
.pagenotfound button{
  padding: .5rem;
}
/* ------end Page not found */

/*-------------- */
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #353434;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(110, 108, 108);
  border-radius: 10px;

}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;4CAC4C;AAC5C;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,gEAAiE;EACjE,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB,YAAY;AACZ,aAAa;AACb,kCAAkC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA,UAAU,aAAa,EAAE;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB,YAAY;AACZ;AACA;EACE,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;;AAGA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;EACZ,sDAAsD;EACtD,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,+BAAuB;UAAvB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,WAAW;AACb;AACA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mFAAmF;AACrF;AACA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;;EAEE;;IAEE,uBAAuB;EACzB;EACA;;IAEE,wBAAwB;EAC1B;AACF;AACA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,yDAA2K;IAC3K,kBAAkB;AACtB;AACA,SAAS;;AAET;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;;AAErB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gEAA+D;EAC/D,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uDAAuD;EACvD,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA,aAAa;;;;AAIb,+DAA+D;AAC/D;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;;AAErB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,yBAAyB,EAAE,qBAAqB;EAChD,aAAa,EAAE,6BAA6B;EAC5C,kBAAkB,EAAE,kCAAkC;EACtD,wCAAwC,EAAE,yBAAyB;AACrE;;;AAGA,sEAAsE;;AAEtE,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,6BAA6B;;AAE7B,kBAAkB;AAClB,UAAU;AACV;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,mBAAmB;;AAErB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans&family=Source+Code+Pro&display=swap');\n\n\n/* font-family: 'Open Sans', sans-serif;\nfont-family: 'Source Code Pro', monospace; */\n:root{\n  --height:95vh;\n}\n\n*{\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Source Code Pro', monospace;\n}\nhtml {\n  scroll-behavior: smooth;\n}\nbody{\n  height: 100vh;\n  width: 100vw;\n}\na{\n  text-decoration: none;\n}\ntextarea{\n  resize: none;\n  color: #fff;\n}\n\n.header{\n  background-color: #c9e0f0;\n  height: 5vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 1rem;\n  padding-right: 1.5rem;\n  font-size: .75rem;\n}\n.header-image{\n  background: url(./assets/kratin_horizontal_logo.png) center/cover;\n  width: 75px;\n  height: 90%;\n}\n.timer{\n  display: flex;  \n  align-items: center;\n  column-gap: 1rem;\n  justify-content: flex-end;\n}\n\n.container{\n  position: absolute;\n  height: var(--height);\nwidth: 100vw;\ndisplay: grid;\ngrid-template-columns: 40% 50% 10%;\n}\n.choose_problem{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.editor-div{\n  height: var(--height);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 1rem 0; \n  overflow-y: scroll;\n  max-width: 60vw;\n}\n.footer-container{\n  display: grid;\n  gap: 1rem;\n  min-width: 21vw;\n  height: var(--height);\n  overflow-y: scroll;\n  justify-content: space-between;\n}\n.editor-footer{\n  margin-top: 1rem; \n  display: grid;\n  grid-template-columns:auto auto auto ;\n  align-items: baseline;\n  column-gap: .5rem;\n}\n.editor-bgclr{\n  background-color: #050c1b;\n}\n.hidden { display: none; }\n.flex{\n  display: flex;\n  align-items: center;\n  justify-content: right;\n  gap: 1.5rem;\n  padding-right: 2rem;\n}\n\n.btn{\n  cursor: pointer;\n  padding: .25rem;\n  color: #fff;\n  font-size: 1rem;\n  text-align: center;\n}\n.bg-none{\n  background: none;\nborder: none;\n}\n.clr-thm{\n  color: #558abf;\n  font-family: 'Source Code Pro', monospace;\n}\n.editor-element-height{\n  height: 2.25rem;\n}\n#select-language{\n  width: 10rem;\n  background-color: #1D2432;\n  color: #fff;\n}\nlabel[for='select-language']{\n  color: #7c7975;\n  margin-right: .5rem;\n  font-size: 1rem;\n}\n.runBtn{\n  background-color: #558abf;\n  border-radius: 5px;\n  font-family: 'Source Code Pro', monospace;\n  padding: .5rem 1rem;\n  flex: 2 2 20em;\n}\n.submitBtn{\n  background-color: #19ad48;\n  border-radius: 5px;\n  font-family: 'Source Code Pro', monospace; \n  padding: .5rem 1rem;\n  flex: 3 3 20em;\n}\n.custom-input{\n  display: flex;\n  align-items: center;\n  flex: 1 1 20em;\n}\n.input-txt{\n  width: 200px;\n  height: 150px;\n  resize: none;\n  padding: 1rem;\n}\n#customInput{\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n}\n\n\n.quesn{\n  background-color: #111827;\n  padding: 2rem;\n  overflow: auto;\n  font-size: 1rem;\n  color: #ccd0d5;\n  border: none;\n  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;\n  line-height: 1.5;\n  resize: none;\n  min-width: 20vw;\n  height: var(--height);\n  display: grid;\n  row-gap: .75rem;\n  overflow-y: scroll;\n}\n.quesn h3{\n  margin-bottom: .5rem;\n  color: #cbc8c4;\n  text-decoration: dashed;\n}\n.quesn ul{\n  padding-left: 2rem;\n}\n.quesn p{\n  padding-left: .5rem;\n}\n\n.output{\n  height: fit-content;\n  width: 100%;\n  z-index: 5;\n  color:white;\n}\n.output .message{\n  height: fit-content;\n  padding-left: 2rem;\n}\n.output .result{\n  display: grid;\n  grid-template-columns: 30% 70%;\n  height: 100%;\n  margin-top: 1rem;\n}\n.bg-gray{\n  background-color: #1D2432;\n}\n.output .testcases{\n  background: #111827;\n}\n\n.io{\n  padding: 2rem;\n  display: grid;\n}\n.pad-2{\n  padding:  1rem 0.5rem;\n}\n.mt{\n  margin-top: .5rem;\n}\n.mb{\n  margin-bottom: 1rem;\n}\n.cl-white{\n  color: #fff;\n}\n\n.checkbox{\n  margin-right: .5rem;\n  accent-color: #558abf;\n  filter: sepia(100%) brightness(60%) hue-rotate(170deg) saturate(70%) contrast(300%);\n}\n/* processing styles */\n.processing{\n  color: #fff;\n  display: flex;\n  align-items: center;\n  column-gap: 1rem;\n  font-size: 1rem;\n  margin-left: 2rem;\n}\n.p-icon{\n  font-size: 1.5rem;\n  animation:animate 2s linear infinite;\n}\n\n@keyframes animate\n{\n  0%\n  {\n    transform:rotate(45deg);\n  }\n  100%\n  {\n    transform:rotate(405deg);\n  }\n}\n/* split and gutter */\n.split {\n    display: flex;\n    flex-direction: row;\n    width: 100vw;\n}\n\n.gutter {\n    background-color: #000;\n    background-repeat: no-repeat;\n    background-position: 50%;\n}\n\n.gutter.gutter-horizontal {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');\n    cursor: col-resize;\n}\n/* Form */\n\n.form {\n  width: 100vw;\n  height: 100vh;\n  padding: 45px 65px;\n  background: linear-gradient(to right, #4e86cf, #27a199);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.form__container{\n  background: #fff;\n  border-radius: 40px;\n}\n.form__box {\n  width: 550px;\n  height: 300px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  \n}\n.warning{\n  width: 100%;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #f51313;\n  column-gap: 1rem;\n}\n.form__left {\n  width: 50%;\n}\n.form__padding {\n  width: 210px;\n  height: 210px;\n  background: #f2f2f2;\n  border-radius: 50%;\n  margin: 0 auto;\n  line-height: 210px;\n  position: relative;\n}\n.form__image {\n  background: url(./assets/kratin_vertical_logo.png) center/cover;\n  width: 80%;\n  height: 80%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.form__right {\n  line-height: 26px;\n  width: 50%;\n}\n.form__padding-right {\n  padding: 0 25px;\n}\n.form__title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: .5rem;\n  margin-top: 20px;\n  color: #4e86cf;\n}\n.form .loginbtn-container{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 1.5rem;\n}\n\n.loginBtn {\n  display: block;\n  width: 70%;\n  height: 40px;\n  border-radius: 20px;\n  border: none;\n  background: linear-gradient(to right, #acc7ea, #539e99);\n  font-size: 1rem;\n  margin-top: 1rem;\n}\n.logoutBtn{\n  border-radius: 20px;\n  background: #69a7f8;\n}\n.header .logoutBtn{\n  padding: .25rem;\n  font-size: .75rem;\n  color: #000;\n}\n.header .logoutBtn:hover {\n  background: #b2e3f4;\n}\n.form .loginBtn:hover {\n  background: linear-gradient(to right, #56b2e0, #bb52db);\n}\n#form__submit-btn{\n  background: #1fcc44;\n  cursor: pointer;\n}\n/* end form */\n\n\n\n/* ------------------------Instructions---------------------- */\n.instruction{\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: url('./assets/bg.svg');\n}\n.ins_container{\n  position: relative;\n  top: 3rem;\n  height: 100vh;\n  width: 1000px;\n  background-color: rgb(251, 251, 251);\n  box-shadow: 0 0px 0px rgb(251, 251, 251);\n  margin-top: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.modal__image{ \n  position: absolute;\n  height: 100px;\n  width: 100px;\n  top: -4% ;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.ins_box{\n  position: absolute;\n  top: 10% ;\n  text-align: left;\n  height: 100%;\n  width: 100%;\n  padding-left: 2rem;\n  padding-right: 1rem;\n\n}\n.ins_box h1, .ins_box h2{\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n.ins_box ul{\n  list-style-type: circle;\n  line-height: 1.5rem;\n}\n.ins_box li{\n  padding-left: 1rem;\n}\n.ins_forward {\n  position: fixed;\n  left: 50%;\n  bottom: 0px;\n  transform: translateX(-50%); \n  background-color: #ffffff; /* Adjust as needed */\n  padding: 1rem; /* Adjust padding as needed */\n  border-radius: 8px; /* Add border-radius for styling */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Add shadow for depth */\n}\n\n\n/* ------------------------End of Instructions---------------------- */\n\n/* ------Page not found */\n.pagenotfound{\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  padding: .5rem;\n}\n.pagenotfound button{\n  padding: .5rem;\n}\n/* ------end Page not found */\n\n/*-------------- */\n/* width */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background: #353434;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: rgb(110, 108, 108);\n  border-radius: 10px;\n\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
